"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdjudicationCategory = exports.MessageType = void 0;
var MessageType;
(function (MessageType) {
    MessageType["text"] = "text";
    MessageType["textSelect"] = "textSelect";
    MessageType["image"] = "image";
})(MessageType || (exports.MessageType = MessageType = {}));
var AdjudicationCategory;
(function (AdjudicationCategory) {
    AdjudicationCategory["adjustable_bed"] = "adjustable_bed";
    AdjudicationCategory["area_rug"] = "area_rug";
    AdjudicationCategory["audio_equipment"] = "audio_equipment";
    AdjudicationCategory["auto_parts"] = "auto_parts";
    AdjudicationCategory["bikes_ebikes"] = "bikes_ebikes";
    AdjudicationCategory["camping"] = "camping";
    AdjudicationCategory["consumer_electronics"] = "consumer_electronics";
    AdjudicationCategory["drones"] = "drones";
    AdjudicationCategory["eyewear"] = "eyewear";
    AdjudicationCategory["general_sporting_goods"] = "general_sporting_goods";
    AdjudicationCategory["grills"] = "grills";
    AdjudicationCategory["gym_equipment"] = "gym_equipment";
    AdjudicationCategory["indoor_furniture"] = "indoor_furniture";
    AdjudicationCategory["iRobot"] = "iRobot";
    AdjudicationCategory["jewelry"] = "jewelry";
    AdjudicationCategory["laptops_tablets_desktops"] = "laptops_tablets_desktops";
    AdjudicationCategory["luggage_bags"] = "luggage_bags";
    AdjudicationCategory["mattress"] = "mattress";
    AdjudicationCategory["mattress_protector"] = "mattress_protector";
    AdjudicationCategory["musical_instrument"] = "musical_instrument";
    AdjudicationCategory["outdoor_furniture"] = "outdoor_furniture";
    AdjudicationCategory["shipping_protection"] = "shipping_protection";
    AdjudicationCategory["tire"] = "tire";
    AdjudicationCategory["vehicle_accessories"] = "vehicle_accessories";
    AdjudicationCategory["watch"] = "watch";
    AdjudicationCategory["wheel"] = "wheel";
    AdjudicationCategory["wheel_tire"] = "wheel_tire";
})(AdjudicationCategory || (exports.AdjudicationCategory = AdjudicationCategory = {}));
